// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface MoveDownIconSignature {
  Element: SVGSVGElement;
}

export const MoveDownIcon: TOC<MoveDownIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 14.0826V2H13V14.0826L15.293 11.8813L16.707 13.2387L12 17.7574L7.293 13.2387L8.707 11.8813L11 14.0826ZM20 21.92V20H4V21.92H20Z"/>
</svg>
</template>;